import * as React from 'react';

import { EXTRA_SMALL_ICON_BASE_SRC } from '../../../../Shared';
import {
  ClassroomLessonSession
} from '../interfaces';
import { sortByLastName } from '../shared/studentSorts';

const LaptopConnectingToLessonsSrc = `${window.postbuildEnv.CDN_URL}/images/illustrations/laptop-connecting-to-lessons.svg`
const checkCircleIcon = `${EXTRA_SMALL_ICON_BASE_SRC}/check-color.svg`

interface LobbyProps {
  title: string,
  data?: ClassroomLessonSession,
  save?: Function,
  projector?: Boolean
}

class Lobby extends React.Component<LobbyProps, {}> {
  renderStudentCard(studentName: string, present: boolean) {
    const cardClass = present ? 'student-card present' : 'student-card'
    return (
      <div className={cardClass} key={studentName}>
        <p>{studentName}</p>
        {present && <img alt="" height={16} src={checkCircleIcon} width={16} />}
      </div>
    )
  }

  renderProjectorView() {
    const { data, } = this.props
    const { students, presence, } = data
    if (!students) { return }

    const studentUidsSortedByLastName: Array<string> = Object.keys(students).sort((key1, key2) => {
      return sortByLastName(key1, key2, students);
    })
    const numberOfStudents = Object.keys(students).length
    const numberOfPresentStudents = presence ? Object.keys(presence).length : 0

    const studentCards = studentUidsSortedByLastName.map(studentUID => {
      const studentName = students[studentUID]
      const present = presence ? !!presence[studentUID] : false
      return this.renderStudentCard(studentName, present)
    })

    return (
      <div className="projector-view">
        <div className="join-banner">
          <span className="join-banner-title">Join the lesson.</span>
          <div className="join-banner-divider" />
          <span>1. Go to quill.org</span>
          <span>2. Log in</span>
          <span>3. Select &#8220;Join&#8221;</span>
        </div>
        <p className="student-count">{numberOfPresentStudents} of {numberOfStudents} students have joined</p>
        <div className="student-grid">
          {studentCards}
        </div>
      </div>
    )
  }

  renderStudentView() {
    return (
      <div className="full-page-modal-container">
        <div className="full-page-modal">
          <img alt="An illustration of a laptop connected to Quill Lessons" src={LaptopConnectingToLessonsSrc} />
          <h1>You&#39;ve joined the lesson!</h1>
          <h2>Wait for other students to join and for your teacher to begin.</h2>
        </div>
      </div>
    )
  }

  renderStudentOrProjectorLobby() {
    const { projector, } = this.props
    return projector ? this.renderProjectorView() : this.renderStudentView()
  }

  render() {
    return (
      <div className="student-lobby">
        {this.renderStudentOrProjectorLobby()}
      </div>
    )
  }
}

export default Lobby;
